import { ChatIaMessage } from "./chat-ia.service";

const STORAGE_PREFIX = "chat-ia:messages";

export const chatIaStorage = {
  load(suffix: string): ChatIaMessage[] {
    try {
      const saved = JSON.parse(sessionStorage.getItem(`${STORAGE_PREFIX}:${suffix}`) || "[]");
      return Array.isArray(saved) ? saved : [];
    } catch {
      return [];
    }
  },

  // el html se descarta: se regenera desde content al cargar
  save(suffix: string, messages: ChatIaMessage[]): void {
    try {
      sessionStorage.setItem(`${STORAGE_PREFIX}:${suffix}`, JSON.stringify(messages.map(({ html, ...rest }) => rest)));
    } catch { /* storage lleno o bloqueado: el chat sigue andando sin persistir */ }
  },

  clear(suffix: string): void {
    try {
      sessionStorage.removeItem(`${STORAGE_PREFIX}:${suffix}`);
    } catch { /* storage bloqueado */ }
  },

  // logout: borra el historial de todos los usuarios y roles
  clearAll(): void {
    try {
      Object.keys(sessionStorage)
        .filter((k) => k.startsWith(`${STORAGE_PREFIX}:`))
        .forEach((k) => sessionStorage.removeItem(k));
    } catch { /* storage bloqueado */ }
  },
};
